import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { FlexLayoutModule } from '@angular/flex-layout';

import { GCADADirectivesModule } from '@GCADA/directives/directives';
import { GCADAPipesModule } from '@GCADA/pipes/pipes.module';

@NgModule({
    imports  : [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        FlexLayoutModule,

        GCADADirectivesModule,
        GCADAPipesModule
    ],
    exports  : [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        FlexLayoutModule,

        GCADADirectivesModule,
        GCADAPipesModule
    ]
})
export class GCADASharedModule
{
}
